import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  Autocomplete,
  FormControl,
  IconButton,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ModalBox } from "../../../styles/ModalStyles";
import { getClienteHabilitado } from "../../http/actions/ClientesAction";
import CloseIcon from "@mui/icons-material/Close";

const EditarEnlaceCongresoModal = ({ open, onClose, onSubmit, enlaceCongreso }) => {
  const [correlativo, setCorrelativo] = useState("");
  const [url, setUrl] = useState("");
  const [titulo, setTitulo] = useState("");
  const [etapa, setEtapa] = useState("");
  const [subEtapa, setSubEtapa] = useState("");
  const [boletin, setBoletin] = useState("");
  const [fecha, setFecha] = useState(null);
  const [xmlSenado, setXmlSenado] = useState("");
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [habilitado, setHabilitado] = useState(false);

  useEffect(() => {
    fetchClientes();
  }, []);

  useEffect(() => {
    if (enlaceCongreso) {
      setCorrelativo(enlaceCongreso.correlativo || "");
      setUrl(enlaceCongreso.url_camara || "");
      setTitulo(enlaceCongreso.titulo || "");
      setEtapa(enlaceCongreso.etapa || "");
      setSubEtapa(enlaceCongreso.subEtapa || "");
      setBoletin(enlaceCongreso.boletin || "");
      setFecha(enlaceCongreso.fecha ? new Date(enlaceCongreso.fecha) : null);
      setXmlSenado(enlaceCongreso.xml_senado || "");
      setHabilitado(enlaceCongreso.habilitado);
      const clienteCorrespondiente = clientes.find(
        (c) => c.id === enlaceCongreso.clienteId
      );
      setClienteSeleccionado(clienteCorrespondiente || null);
    }
  }, [enlaceCongreso, clientes]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...enlaceCongreso,
      correlativo,
      url_camara: url,
      titulo,
      etapa,
      subEtapa,
      boletin,
      fecha: fecha ? fecha.toISOString() : null,
      xml_senado: xmlSenado,
      clienteId: clienteSeleccionado ? clienteSeleccionado.id : null,
      habilitado,
    });
    onClose();
  };

  const fetchClientes = () => {
    getClienteHabilitado(localStorage.getItem("token"))
      .then((response) => {
        setClientes(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6">Editar Enlace de Congreso</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Correlativo"
            value={correlativo}
            onChange={(e) => setCorrelativo(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="URL Cámara"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Título"
            value={titulo}
            onChange={(e) => setTitulo(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Etapa"
            value={etapa}
            onChange={(e) => setEtapa(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Sub Etapa"
            value={subEtapa}
            onChange={(e) => setSubEtapa(e.target.value)}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Boletín"
            value={boletin}
            onChange={(e) => setBoletin(e.target.value)}
            margin="normal"
          />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              sx={{ mt: 2 , width: "100%"}}
              format="dd/MM/yyyy"
              label="Fecha"
              value={fecha}
              onChange={(newValue) => setFecha(newValue)}
              renderInput={(params) => (
                <TextField {...params} fullWidth margin="normal" />
              )}
            />
          </LocalizationProvider>
          <TextField
          sx={{ mt: 3 }}
            fullWidth
            label="XML Senado"
            value={xmlSenado}
            onChange={(e) => setXmlSenado(e.target.value)}
            margin="normal"
          />
          <FormControl fullWidth sx={{ mt: 2 }}>
            <Autocomplete
              noOptionsText="No hay opciones disponibles"
              options={clientes}
              getOptionLabel={(option) => option.nombre || ""}
              renderInput={(params) => (
                <TextField {...params} label="Cliente" />
              )}
              value={clienteSeleccionado}
              onChange={(event, newValue) => {
                setClienteSeleccionado(newValue);
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
          </FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={habilitado}
                onChange={(e) => setHabilitado(e.target.checked)}
                color="primary"
              />
            }
            label={habilitado ? "Habilitado" : "Deshabilitado"}
          />
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mr: 1 }}
            >
              Guardar
            </Button>
            <Button onClick={onClose} variant="contained" color="error">
              Cancelar
            </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default EditarEnlaceCongresoModal;
